/* https://stackoverflow.com/questions/66210996/react-leaflet-display-legend-using-mapcontainer
https://codesandbox.io/s/react-leaflet-display-legend-using-mapcontainer-epv9u */

import { useEffect } from "react";
import L from "leaflet";
import { useLeafletContext } from "@react-leaflet/core";

import { interpolateRainbow, interpolateRdYlGn } from 'd3-scale-chromatic';
import { color } from "d3-color";

import { legend_info, risk_meta } from 'src/constants'

function ramp_html(min_lab: number, max_lab: number) {
    var innerHTML = "";
    for (let i = 0; i <= 1; i += 0.01) {
        innerHTML += '<i style="background: ' + color(interpolateRdYlGn(i))?.formatHex() + '80"></i>';
        if (i == 0 || i > 1 - 0.01) {
            innerHTML += '<i style="width: 10px; background: rgba(0,  0,  0)"></i>';
        }
        if (i > 1 - 0.01) {
            innerHTML += '<span>&nbsp' + min_lab + '</span>';
        }
        if (i == 0) {
            innerHTML += '<span>&nbsp' + max_lab + '</span>';
        }
        innerHTML += '<br>';
    }
    return innerHTML;
}


function Map_legend_2(props: any) {
    const { layerContainer, map } = useLeafletContext();

    console.log(props);

    var legend = props.legend;

    if (legend instanceof L.Control) {
        map.removeControl(props.legend);
    }

    /* This is getting called a bit too often (e.g., where we add points or change
    year. TODO - see if we can fix. For example, could use redux to store a "legend_var"
    variable. Then, only update in Earth_map if current variable is different from legend_var.
    Also, maybe use a "setContent" function
    https://stackoverflow.com/questions/42908826/leaflet-removing-updating-a-legend). */

    useEffect(() => {
        if (map) {
            map.removeControl(props.legend);
            map.removeControl(legend);
            legend.onAdd = () => {
                const div = L.DomUtil.create("div", "info legend");
                var var_info = risk_meta[props.var_name + '_ssp126_2020' as keyof typeof risk_meta];
                div.innerHTML = "<h4>" + legend_info[props.var_name as keyof typeof legend_info] + "</h4><br>" +
                    ramp_html(var_info.variable_min, var_info.variable_max);
                return div;
            };
            legend.addTo(map);
        }
        return () => {
            map.removeControl(legend);
        };
    }, [map, legend, props.var_name]);
    // ^-- https://www.freecodecamp.org/news/react-useeffect-absolute-beginners/
    // "The second argument is an array, called the dependencies array.
    // This array should include all of the values that our side effect relies upon."

    return null;
}

export default Map_legend_2;
